export const API_RESPONSE_STATUS = {
  SUCCESS: 'success',
  FAILURE: 'failure'
};
